import * as React from 'react';
import { Route } from 'react-router-dom';

import DateSelection from './date-selection/date-selection';
import SeatSelection from './seat-selection/seat-selection';
import PersonalInfo from './personal-info/personal-info';
import PaymentInfo from './payment-info/payment-info';
import PaymentResult from './payment-result/payment-result';
import AsiaPayResult from './payment-result/asiapay-result';

const Routes = ({ match }) => (
  <div>
    <Route path={`${match.url}/personal-info`} component={PersonalInfo} />
    <Route path={`${match.url}/seat-selection`} component={SeatSelection} />
    <Route path={`${match.url}/payment-info`} component={PaymentInfo} />
    <Route path={`${match.url}/payment-result/:dr?`} component={PaymentResult} />
    <Route path={`${match.url}/asiapay-result/:result`} component={AsiaPayResult} />
    <Route path={`${match.url}/date-selection/:eventId?`} component={DateSelection} />
  </div>
);

export default Routes;
